module.exports = " <div class=job-container> <h1 class=title> <span class=title-text> {{ job.title }} </span> </h1> <article class=\"container col-lg-6\"> <div class=description> {{{job.description}}} </div> <application-form keep-alive></application-form> </article> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewJob.vue
// module id = 161
// module chunks = 2